// extracted by mini-css-extract-plugin
module.exports = {"container":"Chart_container__1PIOn","canvas":"Chart_canvas__3MWkM"};